module.exports = __webpack_public_path__ + "static/media/tomb.0a058f2d.svg";